"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineAbilityFor = exports.HoneAbilitySubjects = exports.HoneAbilityActions = void 0;
const ability_1 = require("@casl/ability");
exports.HoneAbilityActions = {
    create: "create",
    delete: "delete",
    manage: "manage",
    read: "read",
    update: "update"
};
exports.HoneAbilitySubjects = {
    all: "all",
    Bookkeeper_Controls: "Bookkeeper Controls",
    Employee_Controls: "Employee Controls",
    Internal_Controls: "Internal Controls",
    Owner_Controls: "Owner Controls",
    Queue: "Queue",
    System: "System",
    User: "User"
};
const defineAbilityFor = (abilities) => (0, ability_1.defineAbility)((can) => {
    if (abilities.length > 0) {
        abilities.forEach((a) => {
            can(a.action, a.subject);
        });
    }
});
exports.defineAbilityFor = defineAbilityFor;
//# sourceMappingURL=Ability.js.map